import { FC } from 'react';
import { IOption } from 'components/elements/CustomSelect';
import { CustomModal } from 'components/elements/CustomModal';
import { IStreetFormValues } from 'types';
import { StreetForm } from '../StreetForm';

interface ManageStreetModalProps {
	isOpen: boolean;
	onClose: () => void;
	initialValues: IStreetFormValues;
	initialCityTitle?: string;
	onSubmit: (values: IStreetFormValues) => void;
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	onCitySearch: (search: string) => void;
	onCityLoadMore: () => void;
	hasMoreCityOptions: boolean;
	buttonText: string;
	title: string;
}

export const ManageStreetModal: FC<ManageStreetModalProps> = ({
	isOpen,
	onClose,
	initialValues,
	initialCityTitle,
	onSubmit,
	cityOptions,
	cityOptionsLoading,
	onCitySearch,
	onCityLoadMore,
	hasMoreCityOptions,
	buttonText,
	title,
}) => {
	return (
		<CustomModal open={isOpen} onClose={onClose} title={title} maxWidth="md" fullWidth>
			<StreetForm
				initialValues={initialValues}
				initialCityTitle={initialCityTitle}
				onSubmit={onSubmit}
				buttonText={buttonText}
				cityOptions={cityOptions}
				cityOptionsLoading={cityOptionsLoading}
				onCitySearch={onCitySearch}
				onCityLoadMore={onCityLoadMore}
				hasMoreCityOptions={hasMoreCityOptions}
			/>
		</CustomModal>
	);
};
